function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bc1f2f;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M56.26,114.09a55.77,55.77,0,0,1-23.46-5.46A60.47,60.47,0,0,1,13,93.26c-.32-.38-8-9.74-10.88-20.89a56.6,56.6,0,0,1-1.72-22c0-.3.63-11,8.71-24.36.28-.42,6-9.18,13.85-14.77A59.33,59.33,0,0,1,44,1.45c.45-.11,11.64-2.75,22.53-.63A63,63,0,0,1,87.46,8.67l1.41.83L80.38,28.57l-1.8-1.12c-.11-.07-11-6.82-21.63-6.11,0,0-.05,0-.1,0a38.8,38.8,0,0,0-18.31,5.27,39.57,39.57,0,0,0-9.79,8.85,38.6,38.6,0,0,0-5.89,11.82,36.77,36.77,0,0,0-.7,16.7,38.18,38.18,0,0,0,6.93,15,36.77,36.77,0,0,0,12.09,9.9A35.87,35.87,0,0,0,62,92.24a32.44,32.44,0,0,0,14.75-5.66c.23-.14,5.81-3.39,11.56-13.26,0,0,.93-1.63,3.12-6.64l9.46-23.26L118.34,1.57h19.77L172,83.64,205.58,1.56l19.61,0,45.72,110.27H248.08L237.73,87.05l-44.42,0-10.26,24.72-22.18,0L150.51,87H105.07a108.56,108.56,0,0,1-9.63,11.77c-.11.14-5,6-15.52,10.5a54.25,54.25,0,0,1-22.4,4.81C57.42,114.07,57,114.09,56.26,114.09ZM57.45,3.69A60.73,60.73,0,0,0,44.83,5a56.61,56.61,0,0,0-19.65,9.18C17.86,19.45,12.3,27.91,12.24,28,4.71,40.45,4.08,50.63,4.08,50.74a54.09,54.09,0,0,0,1.6,20.63C8.34,81.79,15.79,90.83,15.86,90.92a57.74,57.74,0,0,0,18.5,14.38,52.19,52.19,0,0,0,23,5.09,51.22,51.22,0,0,0,20.94-4.47c9.73-4.22,14.31-9.58,14.35-9.63a108.41,108.41,0,0,0,9.89-12.19l.55-.8h49.82l10.36,24.76,17.28,0,10.26-24.71,49.32,0,10.35,24.77h14.87L222.72,5.2,208,5.22,172,93.29,135.63,5.23H120.78L104.29,44.8,94.82,68.09c-2.32,5.32-3.29,7-3.33,7.07C85.18,86,79,89.53,78.72,89.67a35.13,35.13,0,0,1-16.31,6.22,38.78,38.78,0,0,1-22.93-3.75,39.68,39.68,0,0,1-13.31-10.9,41.11,41.11,0,0,1-7.64-16.58,39.78,39.78,0,0,1,.81-18.5,41.52,41.52,0,0,1,6.52-13,42.81,42.81,0,0,1,10.81-9.73,41.4,41.4,0,0,1,20.18-5.75c9-.6,18.05,3.59,21.82,5.62l5.46-12.26A59.8,59.8,0,0,0,65.87,4.48,41.47,41.47,0,0,0,57.45,3.69ZM235.06,70l-38.76,0,18.84-47.67Zm-33.35-3.71,27.82,0L215.23,32ZM147.64,70l-38.76,0,18.85-47.67Zm-33.35-3.71,27.83,0L127.83,32Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M76.19,247.65H64.13c-5.28,0-5.43-6.64-5.43-7.54-5,5-10,8.9-21.87,8.9-15.38,0-29.41-7.09-29.41-24.58,0-22.92,18.85-25.34,38.91-26.09,8.14-.3,11.91-3.17,11.91-7.69,0-5.28-6-10.4-15.38-10.4-7.69,0-15.23,3-19.91,9.5L12.24,180.4c6.94-9.2,18.55-13.87,30.61-13.87,18.4,0,30.76,10.1,30.76,29.56v45.69c0,1.05.6,3.17,2.56,3.17v2.7ZM58.84,211.91v-4.52c-3.32,4.67-13.72,3.92-18.7,4.22-14.93.75-16.29,8.6-16.29,12.82,0,3.77,2.56,11.46,13,11.46C56.28,235.89,58.84,225,58.84,211.91Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M84.67,247.65V140.59h16.44V247.66H84.67Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M113.63,167.88h16.44v48.71c0,15.08,8,18.25,13.87,18.25,11.16,0,24.88-5.43,24.88-34.08V167.89h16.44v79.77H168.82l-3.32-8A32.91,32.91,0,0,1,143,249c-21,0-29.41-11.61-29.41-31.37V167.88Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M310.9,247.65H294.46v-47.8c0-10.41-2.11-18.7-13.42-18.7-9.8,0-17.19,5.58-17.19,33.63v32.87H247.41v-46c0-8-1.51-20.51-13.42-20.51-16,0-19.15,16.44-19.15,30v36.49H198.4V167.88h16.29l2.72,6.94c5.73-6.18,11.91-8.29,17.49-8.29,6.78,0,17.95,1.66,23.68,12.06,7.84-10,18.1-12.06,22.47-12.06,29.41,0,29.86,21.56,29.86,35.14v46Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M395.43,247.65H379V198.94c0-15.08-8-18.25-13.87-18.25-11.16,0-24.88,5.43-24.88,34.08v32.87H323.8V167.87h16.43l3.32,8A32.91,32.91,0,0,1,366,166.51c21,0,29.4,11.61,29.4,31.37v49.77Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M425.28,158.38H407.64V140.59h17.64Zm-17,9.5h16.44v79.77H408.24Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M83.27,383.65H66.83V334.94c0-15.08-8-18.25-13.87-18.25-11.16,0-24.88,5.43-24.88,34.08v32.87H11.64V303.87H28.08l3.32,8a32.91,32.91,0,0,1,22.47-9.35c21,0,29.4,11.61,29.4,31.37Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M169.3,349.87H107.77c1.66,13.87,8.9,20.51,23.52,20.51,11.31,0,18.25-4.22,22.32-11.16l12.21,7.24c-6.18,10.86-19,18.55-34.53,18.55-24.43,0-39.51-15.83-39.51-41.17,0-23.68,15.23-41.32,39.51-41.32,23.07,0,37.1,16.29,38,39.81v7.54Zm-14.93-14.62c-2.11-11.61-11.16-18.55-23.07-18.55-11.46,0-20.51,6.48-23.07,18.55Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M210.67,370.08a36.35,36.35,0,0,0,8.75-.91v14A105.5,105.5,0,0,1,202.68,385c-12.67,0-19.9-5.28-19.9-25.33V318.2H167.7V303.88h15.08v-27.3h16.29v27.3h20.36V318.2H199.07v40.11C199.06,367.37,203.43,370.08,210.67,370.08Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M265.25,383.65H249.57l-24.28-79.77h17l15.08,54.59,15.08-54.59h18.7l15.08,54.59,15.08-54.59h17l-24.28,79.77H298.43l-16.59-56.4Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M375,385c-22.17,0-39.81-18.55-39.81-41.17,0-21,16-41.32,39.81-41.32,23.53,0,39.51,20.36,39.51,41.32C414.52,366.31,398.53,385,375,385Zm23.22-41.17c0-13.57-8-27.14-23.22-27.14-14.78,0-23.53,12.82-23.53,27.14,0,14,8.14,27,23.53,27C389.33,370.83,398.23,357.87,398.23,343.84Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M471.25,303.13V317.3a21.14,21.14,0,0,0-5.88-.6c-13.12,0-25.79,7.69-25.79,35.89v31.07H423.3V303.89h16.29l3.62,9.2c7.09-7.24,15.53-10.56,22.17-10.56A33.3,33.3,0,0,1,471.25,303.13Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M552,383.65H531.94l-25.18-38.3L492,361.64v22H475.54V276.58H492v62.73l31.52-35.44h21.11l-27,29.71Z"
});

var SvgAlumniLogo = function SvgAlumniLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 552 385.01",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlumniLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alumniLogo.469753b4.svg";
export { ForwardRef as ReactComponent };